"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canRunLogHandler = void 0;
function isDebugLoggingEnabled(pinoMessage) {
    if (typeof window !== 'undefined') {
        return false;
    }
    return pinoMessage.enableDebugLogging;
}
var canRunLogHandler = function(param) {
    var loggerConfiguration = param.loggerConfiguration, pinoMessage = param.pinoMessage, transportType = param.transportType;
    var minimalSeverityLevel = loggerConfiguration.minimalSeverityLevel, loggingEnabled = loggerConfiguration.enabled, _loggerConfiguration_filters = loggerConfiguration.filters, filters = _loggerConfiguration_filters === void 0 ? [] : _loggerConfiguration_filters;
    if (isDebugLoggingEnabled(pinoMessage)) {
        return true;
    }
    // Entire logging disabled then just return right away
    if (!loggingEnabled) {
        return false;
    }
    var canRunHandler = false;
    var matchedAnyFilter = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var filter = _step.value;
            var shouldRunForRule = filter.enabled, byName = filter.byName, byAreaName = filter.byAreaName, byNameRegExp = filter.byNameRegExp, byAreaNameRegExp = filter.byAreaNameRegExp, byMinimalSeverityLevel = filter.byMinimalSeverityLevel, byTransportType = filter.byTransportType;
            if (byTransportType !== undefined && byTransportType !== transportType) {
                continue;
            }
            var minimalSeverityLevelWithDefault = byMinimalSeverityLevel !== null && byMinimalSeverityLevel !== void 0 ? byMinimalSeverityLevel : minimalSeverityLevel;
            if (minimalSeverityLevelWithDefault > pinoMessage.level) {
                continue;
            }
            if (byName !== undefined && byName !== pinoMessage.name) {
                continue;
            }
            if (byNameRegExp !== undefined && pinoMessage.name && !byNameRegExp.test(pinoMessage.name)) {
                continue;
            }
            if (byAreaName !== undefined && pinoMessage.areaName && byAreaName !== pinoMessage.areaName) {
                continue;
            }
            if (byAreaNameRegExp !== undefined && pinoMessage.areaName && !byAreaNameRegExp.test(pinoMessage.areaName)) {
                continue;
            }
            // If some filter passes then inherit the configuration from that filter
            matchedAnyFilter = true;
            canRunHandler = shouldRunForRule;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return matchedAnyFilter ? canRunHandler : pinoMessage.level >= minimalSeverityLevel;
};
exports.canRunLogHandler = canRunLogHandler; //# sourceMappingURL=canRunLogHandler.js.map
